import { Button, Typography } from '@eventbrite/marmalade';
import { useIntl } from 'react-intl';
import { FAQ_LINKS, messages } from './constants';
import styles from './LandingView.module.scss';

interface Props {
  onContactClick: () => void;
}

export function LandingView({ onContactClick }: Props) {
  const intl = useIntl();

  return (
    <div className={styles.root}>
      <section className={styles.faqSection}>
        <Typography variant="body-lg">{intl.formatMessage(messages.faqHeading)}</Typography>
        <ul className={styles.faqList}>
          {FAQ_LINKS.map(({ articleNumber, messageKey }) => (
            <li key={articleNumber}>
              <Typography variant="body-md" as="span">
                <a
                  href={`/support/articleredirect?anum=${articleNumber}`}
                  target="_blank"
                  rel="noopener noreferrer"
                  className={styles.faqLink}
                >
                  {intl.formatMessage(messages[messageKey])}
                </a>
              </Typography>
            </li>
          ))}
        </ul>
      </section>

      <section className={styles.contactSection}>
        <Typography variant="body-md-bold">{intl.formatMessage(messages.haveQuestion)}</Typography>
        <Typography variant="body-md">{intl.formatMessage(messages.checkEventPage)}</Typography>
        <div className={styles.ctaWrapper}>
          <Button variant="primary" onClick={onContactClick}>
            {intl.formatMessage(messages.contactOrganizer)}
          </Button>
        </div>
      </section>
    </div>
  );
}
